import portrait_bielman from '$lib/assets/images/portrait_bielman.jpg';
import portrait_menoud from '$lib/assets/images/portrait_menoud.jpg';
import portrait_jordan from '$lib/assets/images/portrait_jordan.png';

export const formOpen = $state({ status: false });
export const quizOpen = $state({ status: false });
export const selectedMaster: { idx: number | null } = $state({ idx: null });
export const quizAnswers: string[] = $state([]);

export const masters = [
	{
		image: portrait_bielman,
		firstName: 'Jean-François',
		lastName: 'Bielmann',
		expert: '200 000 cheeses selected every year',
		drive: '60 future Maîtres Fromagers mentored',
		beyond: '12 000 hours spent wandering in Swiss mountains',
		text:
			'Jean-François grew up listening closely, to music, to people, and even to the sound a wheel of cheese makes when tapped. An alpine cheese specialist, he believes quality lives in the smallest details. As a mentor in cheesemaking schools, he’s passionate about passing knowledge forward and shaping the next generation.\n' +
			'For him, great cheese has always been about people, from dairy farmers to customers, and the connections built along the way.'
	},
	{
		image: portrait_menoud,
		firstName: 'Gérald ',
		lastName: 'Menoud',
		expert: '35 years shaping exceptional cheese craft',
		drive: '36 cheesemakers guided to elevate quality',
		beyond: '+1000 alpine escape to reconnect with nature',
		text:
			'For Gérald, cheese is a family matter. He grew up surrounded by the craft and developed an early passion for what makes a cheese truly exceptional. A Gruyère specialist and technical advisor, he believes great cheese begins with the right balance of milk quality, terroir and expertise.\n' +
			'On weekends, skiing and mountain trails bring him the same thing he looks for in cheese: authenticity, balance and nothing superfluous.\n'
	},
	{
		image: portrait_jordan,
		firstName: 'Ludovic',
		lastName: 'Jordan',
		expert: '+160 relationships nurtured with dairy farmers and cheesemakers',
		drive: '1 belief: great cheese is shaped by every hand',
		beyond: '40 evenings spent playing French horn',
		text:
			'Ludovic grew up in the Swiss countryside, where he developed a fascination with one simple transformation: how does milk become cheese? Guided by authenticity, craftsmanship and human connection, he believes every wheel carries a story worth sharing.\n' +
			'Away from work, he plays the French horn in a local group. A balance that reflects who he is: precise, curious, and driven by meaningful connections.'
	}
];

export const questions = [
	{
		question: 'When exploring the world of cheese, what draws your attention first?',
		answers: [
			{
				text: 'The people and craftsmanship behind it',
				value: 'a'
			},
			{
				text: 'The story behind the wheel, its people and market potential',
				value: 'b'
			},
			{
				text: 'The cheese itself: technical details, flavor profile and texture',
				value: 'c'
			}
		]
	},
	{
		question: 'How do you want your Maître Fromager to guide your cheese journey?',
		answers: [
			{
				text: 'Through heritage and pedagogical approach',
				value: 'a'
			},
			{
				text: 'Through collaboration and opportunity building',
				value: 'b'
			},
			{
				text: 'Through technical mastery and deep product expertise',
				value: 'c'
			}
		]
	},
	{
		question:
			'If you could spend a day at Mifroma in Switzerland, which experience would you choose first?',
		answers: [
			{
				text: 'Experience the cheesemakers’ life in the mountains',
				value: 'a'
			},
			{
				text: 'Meet all the people behind a cheese wheel',
				value: 'b'
			},
			{
				text: 'Learn the science behind every cheese',
				value: 'c'
			}
		]
	},
	{
		question:
			'We believe great cheese reflects a balanced lifestyle, what best resonates with you?',
		answers: [
			{
				text: 'Finding your everyday rhythm through human connection',
				value: 'a'
			},
			{
				text: 'Cultivating cultural knowledge through music and shared experiences',
				value: 'b'
			},
			{
				text: 'Escaping into high alpine nature and adventure',
				value: 'c'
			}
		]
	}
];
